import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=21004a81&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=21004a81&prod&lang=scss&scoped=true&"
import style1 from "./Avatar.vue?vue&type=style&index=1&id=21004a81&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21004a81",
  null
  
)

export default component.exports